import React from "react";
import { ReactComponent as Checked } from "../../assets/icons/checkbox-fill.svg";
import { ReactComponent as Unchecked } from "../../assets/icons/checkbox-blank-line.svg";

const Checkbox = ({ checked, onChange, size, disabled }) => {
  return (
    <div onClick={!disabled ? onChange : null}>
      {size ? (
        <>
          {checked ? (
            <Checked width={size} height={size} className="pointer" />
          ) : (
            <Unchecked
              style={{ color: disabled ? "gray" : "#484888" }}
              width={size}
              height={size}
              className="pointer"
            />
          )}
        </>
      ) : (
        <>
          {checked ? (
            <Checked width={38} height={38} className="pointer" />
          ) : (
            <Unchecked
              style={{ color: disabled ? "gray" : "#484888" }}
              width={38}
              height={38}
              className="pointer"
            />
          )}
        </>
      )}
    </div>
  );
};

export default Checkbox;
